import { needsQuotes } from "./needsQuotes.js";
class Unquoted {
  constructor(value) {
    this.value = value;
  }
}
function objectToString(obj, indent = 0) {
  const parts = [];
  const indentation = " ".repeat(indent);
  const innerIndentation = " ".repeat(indent + 2);
  if (Object.keys(obj).length === 0) {
    return "{}";
  }
  for (const [key, value] of Object.entries(obj)) {
    const formattedKey = needsQuotes(key) ? `'${key}'` : key;
    if (value instanceof Unquoted) {
      const lines = value.value.split("\n");
      let formattedValue = `${value.value}`;
      if (lines.length > 1) {
        formattedValue = lines.map((line, index) => {
          if (index === 0) {
            return line;
          }
          return `${innerIndentation}${line}`;
        }).join("\n");
      }
      parts.push(`${innerIndentation}${formattedKey}: ${formattedValue}`);
    } else if (Array.isArray(value)) {
      const items = value.map((item) => {
        if (typeof item === "string") {
          return `'${item}'`;
        }
        if (item && typeof item === "object") {
          return objectToString(item);
        }
        return JSON.stringify(item);
      });
      if (items.some((item) => item.includes("\n"))) {
        const arrayString = items.map((item) => indentString(item, indent + 4)).join(",\n");
        parts.push(`${innerIndentation}${formattedKey}: [
${arrayString}
${innerIndentation}]`);
      } else {
        parts.push(`${innerIndentation}${formattedKey}: [${items.join(", ")}]`);
      }
    } else if (value && typeof value === "object") {
      parts.push(`${innerIndentation}${formattedKey}: ${objectToString(value, indent + 2)}`);
    } else if (typeof value === "string") {
      const formattedValue = `'${value}'`;
      parts.push(`${innerIndentation}${formattedKey}: ${formattedValue}`);
    } else {
      parts.push(`${innerIndentation}${formattedKey}: ${value}`);
    }
  }
  return `{
${parts.join(",\n")}
${indentation}}`;
}
function indentString(str, indent) {
  const indentation = " ".repeat(indent);
  return str.split("\n").map((line) => `${indentation}${line}`).join("\n");
}
export {
  Unquoted,
  objectToString
};
//# sourceMappingURL=objectToString.js.map
